import { TIME_EXPIRATION_CONTAINERS } from '@helpers/constants.tsx';
import { Simulation } from '@helpers/types.ts';
import { Add, CloudDownload } from '@mui/icons-material';
import { Button, Divider, IconButton, Paper } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { differenceInHours } from 'date-fns';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/es';
import { useMemo } from 'react';

interface IStationSelectProps {
  date: any;
  rows: Array<Simulation>;
  onChangeDate: any;
  onDownload: () => void;
  loadingDownload: boolean;
  loadingInduction: boolean;
  startInduction: () => void;
  inductSelection: Array<string>;
}

export const ToolbarSimulations = (props: IStationSelectProps) => {
  const oldDate = useMemo(() => {
    return props.rows
      .map((r) => new Date(r.created_at))
      .sort((a, b) => b.getTime() - a.getTime())[0];
  }, [props.rows]);
  return (
    <Paper
      variant="outlined"
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <IconButton
        color="primary"
        disabled={props.inductSelection.length == 0 || props.loadingDownload}
        onClick={props.onDownload}
      >
        <CloudDownload />
      </IconButton>
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <Button
        color="primary"
        disabled={
          props.inductSelection.length == 0 ||
          props.loadingInduction ||
          differenceInHours(new Date(), oldDate) > TIME_EXPIRATION_CONTAINERS
        }
        onClick={props.startInduction}
      >
        Inducir
      </Button>
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <DatePicker
          value={dayjs(props.date)}
          format="DD/MMM/YYYY"
          onChange={(newValue: Dayjs | null) => {
            if (newValue) {
              props.onChangeDate(newValue.toDate());
            }
          }}
          slotProps={{
            textField: {
              size: 'small',
              variant: 'standard',
              sx: { mx: 1, minWidth: 140 },
              InputProps: {
                disableUnderline: true,
              },
            },
          }}
        />
      </LocalizationProvider>
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      {/*<IconButton color="primary" href={'/configure-plan-stack'}>
        <Queue />
      </IconButton>
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />*/}
      <Button color="primary" startIcon={<Add />} href={'/configure-plan'}>
        Planear
      </Button>
    </Paper>
  );
};
